import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import DashboardLayout from './layouts/dashboard';
import LogoOnlyLayout from './layouts/LogoOnlyLayout';
import SimpleLayout from './layouts/SimpleLayout';
import PlanManager from './pages/Plans';
// 
import Login from './pages/Login'; 
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/Reset';

import NotFound from './pages/Page404';
import { isLogin, checkPageAccess } from './utils/protector';

import Activate from './pages/Activate';
import Dashboard from './pages/Dashboard';
import MerchantRegister from './pages/Merchant/register';
import Users from './pages/Castlenova/User';
import Region from './pages/Castlenova/Region';
import MasterAgents from './pages/Castlenova/MasterAgent';
import Agents from './pages/Castlenova/Agent';
import ApprovedMerchants from './pages/Castlenova/Merchant/approved';
import ReviewMerchants from './pages/Castlenova/Merchant/review';
import RejectedMerchants from './pages/Castlenova/Merchant/rejected';
import DeactivatedMerchants from './pages/Castlenova/Merchant/deactivated'; 
import States from './pages/Castlenova/States';
import Reason from './pages/Merchant/Reason';

import Customer from './pages/Merchant/Customer';
import Employee from './pages/Merchant/Employee';
import Role from './pages/Merchant/Role';
import Discount from './pages/Merchant/Discounts';
import Category from './pages/Merchant/Inventory/Category';
import ProductService from './pages/Merchant/Inventory/Products';
import Tax from './pages/Merchant/Settings/Tax';
import CommissionPayment from './pages/Merchant/Settings/DefaultCommission';
import DefaultDiscountDivision from './pages/Merchant/Settings/DefaultDiscountDivision';
import EmployeeSetting from './pages/Merchant/Settings/EmployeeSpecificSetting';
import UserProfile from './pages/Profile';
import GiftCards from './pages/Merchant/GiftCards';
import LoyaltyPoints from './pages/Merchant/Settings/LoyaltyPoints';
import Batches from './pages/BatchReports';
import TipSuggestions from './pages/Merchant/Settings/TipSuggestion';
import PrinterDriverDownload from'./pages/Merchant/Settings/PrinterDrivers';
// import LPSettings from './pages/Merchant/Settings/LPSettings';
// import LPActivationSettings from './pages/Merchant/Settings/LPActivationSettings';
// import LoyaltyRedeemSettings from './pages/Merchant/Settings/LPRedeemSettings';
import NotAuthorized from './pages/notauthorized';

import Payout from './pages/Payout';
import Reports from './pages/reports'; 
import Transactions from './pages/Transactions';

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    // {
    //   path: '/dashboard', 
    //   element: isLogin() ? <DashboardLayout /> : <Navigate to="/login"/>,
    //   children: [
    //     // { element: <Navigate to="/dashboard/app" replace /> },
    //     { path: 'app', element: <Dashboard /> },
    //     { path: '', element: <Dashboard /> }, 
    //     { path: 'users', element: <Users /> }, 
    //     // { path: 'user', element: <User /> },
    //     // { path: 'products', element: <Products /> },
    //     // { path: 'blog', element: <Blog /> },
    //   ],
    // },
    {
      path: '/app', 
      element: isLogin() ? <DashboardLayout /> : <Navigate to="/login"/>,
      children: [
        { path: '', element: <Dashboard /> }, 
        { path: 'region', element: !checkPageAccess('Region') ?<NotAuthorized /> : <Region />   },  
        { path: 'employees', element: !checkPageAccess('User.Admin') && !checkPageAccess('User.Staff') ?<NotAuthorized /> :<Users /> }, 
        { path: 'masteragents', element: !checkPageAccess('User.MasterAgents') ?<NotAuthorized /> :<MasterAgents /> }, 
        { path: 'agents', element: !checkPageAccess('User.Agents') ?<NotAuthorized /> :<Agents /> },
        { path: 'merchants/review', element: !checkPageAccess('Merchant.Review') ? <NotAuthorized /> : <ReviewMerchants /> },
        { path: 'merchants/approved', element: !checkPageAccess('Merchant.Approved') ? <NotAuthorized /> : <ApprovedMerchants /> }, 
        { path: 'merchants/rejected', element: !checkPageAccess('Merchant.Rejected') ? <NotAuthorized /> :<RejectedMerchants /> },
        { path: 'merchants/deactivated', element: !checkPageAccess('Merchant.Deactivated') ?<NotAuthorized /> : <DeactivatedMerchants /> }, 
        { path: 'states', element: <States/> },
        { path: 'plans', element: <PlanManager/> },
        /** MERCHANT PANEL ROUTES */
        { path: 'customer', element:!checkPageAccess('Customer') ?<NotAuthorized /> :  <Customer /> }, 
        { path: 'reasons', element:!checkPageAccess('Reason') ?<NotAuthorized /> :  <Reason /> }, 
        { path: 'employee', element: !checkPageAccess('Employee') ?<NotAuthorized /> :<Employee /> }, 
        { path: 'roles', element: !checkPageAccess('Role') ?<NotAuthorized /> :<Role /> }, 
        { path: 'discount', element: !checkPageAccess('Discount') ?<NotAuthorized /> :<Discount /> }, 
        { path: 'category', element: !checkPageAccess('Inventory') ?<NotAuthorized /> :<Category />}, 
        { path: 'product', element: !checkPageAccess('Inventory') ?<NotAuthorized /> :<ProductService />}, 
        { path: 'tax', element: !checkPageAccess('Tax') ?<NotAuthorized /> :<Tax />},
        { path: 'commissionpayment', element: !checkPageAccess('DefaultCommission') ?<NotAuthorized /> :<CommissionPayment />},
        { path: 'defaultdiscount', element: !checkPageAccess('DefaultDiscount') ?<NotAuthorized /> :<DefaultDiscountDivision />},
        { path: 'employeesetting', element: !checkPageAccess('EmpSettings') ?<NotAuthorized /> :<EmployeeSetting />},
        { path: 'profile', element: <UserProfile/>},
        { path: 'batches', element: <Batches/>},
        { path: 'loyaltypointsettings', element: !checkPageAccess('LoyaltyPoints') ?<NotAuthorized /> :<LoyaltyPoints/>},
        { path: 'tipsuggestion', element: !checkPageAccess('TipSuggestions') ?<NotAuthorized /> :<TipSuggestions/>},
        { path: 'PrinterDriverDownload', element: !checkPageAccess('PrinterDriverDownload') ?<NotAuthorized /> :<PrinterDriverDownload/>},
        // { path:'loyaltyactivatesettings', element: <LPActivationSettings/>},
        { path: 'giftcards', element: !checkPageAccess('GiftCard') ?<NotAuthorized /> :<GiftCards/>},
        // { path: 'loyaltyredeemsettings', element: <LoyaltyRedeemSettings/>}
        { path: 'payout', element:!checkPageAccess('Payout') ?<NotAuthorized /> : <Payout/>},
        { path: 'reports', element: !checkPageAccess('Report') ?<NotAuthorized /> :<Reports/>},
        { path: 'transactions', element: !checkPageAccess('Transactions') ?<NotAuthorized /> :<Transactions/> }
      ],
    },

    {
      path: '/merchant', 
      element: <DashboardLayout />,
      children: [
        { path: '', element: <Dashboard /> }, 
        { path: 'region', element: <Region /> },  
        { path: 'employees', element: <Users /> }, 
        { path: 'masteragents', element: <MasterAgents /> }, 
      ],
    },
    {
      path: 'login',
      element: <Login />,
    },
    {
      path: 'forgot',
      element: <ForgotPassword />,
    },
    {
      path: 'reset',
      element: <SimpleLayout />,
      children:[
        {path:":authcode", element:<ResetPassword/>}
      ]
    },
    {
      path: 'register',
      element: <LogoOnlyLayout />,
      children: [
        { path: '', element: <MerchantRegister /> }, 
      ]
    },
    {
      path: 'activate',
      element: <SimpleLayout />,
      children:[
        {path:":authcode", element:<Activate/>}
      ]
    }, 
    {
      path: '/',
      element: !isLogin() ? <LogoOnlyLayout /> : <Navigate to="/app"/>,
      children: [
        { path: '/', element: <Navigate to="/login" /> },
        { path: '404', element: <NotFound /> },
        { path: '*', element: <Navigate to="/404" /> },
      ],
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
  ]);
}
